(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calgary-location-story"] && !Shopify.designMode) return;
  try {
    
(()=>{const section=document.getElementById('calgary-showroom');if(!section)return;const placeQuery='Canadian Mattress Wholesalers, 6624 Centre Street S, Calgary, AB T2H 0C6';const key='AIzaSyBEUAumDxCngVix8WBExKBRYbRK4gyigxs';const escape=s=>String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));window.__initCalgaryReviews=()=>{const service=new google.maps.places.PlacesService(document.createElement('div'));service.findPlaceFromQuery({query:placeQuery,fields:['place_id']},(results,findStatus)=>{if(findStatus!==google.maps.places.PlacesServiceStatus.OK||!results?.[0])return;service.getDetails({placeId:results[0].place_id,fields:['url','rating','user_ratings_total','reviews']},(place,status)=>{if(status!==google.maps.places.PlacesServiceStatus.OK)return;const aggregate=section.querySelector('#gm-aggregate');const link=section.querySelector('#gm-open-google');const track=section.querySelector('#gm-reviews-track');if(place.rating&&place.user_ratings_total)aggregate.textContent=`${place.rating.toFixed(1)} / 5 from ${place.user_ratings_total} Google reviews`;if(place.url)link.href=place.url;const reviews=(place.reviews||[]).slice(0,5);if(!reviews.length)return;track.innerHTML='';reviews.forEach(review=>{const card=document.createElement('article');const text=escape(review.text||'');const author=escape(review.author_name||'Google customer');card.innerHTML=`<div class="cloc__review-author"><span aria-hidden="true">${author.slice(0,1)}</span><div><strong>${author}</strong><br><small>${escape(review.relative_time_description||'')}</small></div></div><strong aria-label="${review.rating} out of 5 stars">★★★★★</strong><p>${text.length>360?`${text.slice(0,357)}…`:text}</p>`;track.appendChild(card)})})})};if(window.google?.maps?.places){window.__initCalgaryReviews();return}if(!document.querySelector('[data-calgary-google-places]')){const script=document.createElement('script');script.src=`https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&callback=__initCalgaryReviews`;script.async=true;script.defer=true;script.dataset.calgaryGooglePlaces='true';document.head.appendChild(script)}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edmonton-location-story"] && !Shopify.designMode) return;
  try {
    
(()=>{const section=document.getElementById('edmonton-showroom');if(!section)return;const placeId='ChIJtRseMFkZoFMRPEfj3NkAigs';const key='AIzaSyBEUAumDxCngVix8WBExKBRYbRK4gyigxs';const escape=s=>String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));window.__initEdmontonReviews=()=>{const service=new google.maps.places.PlacesService(document.createElement('div'));service.getDetails({placeId,fields:['url','rating','user_ratings_total','reviews']},(place,status)=>{if(status!==google.maps.places.PlacesServiceStatus.OK)return;const aggregate=section.querySelector('#gm-aggregate');const link=section.querySelector('#gm-open-google');const track=section.querySelector('#gm-reviews-track');if(place.rating&&place.user_ratings_total)aggregate.textContent=`${place.rating.toFixed(1)} / 5 from ${place.user_ratings_total} Google reviews`;if(place.url)link.href=place.url;const reviews=(place.reviews||[]).slice(0,5);if(!reviews.length)return;track.innerHTML='';reviews.forEach(review=>{const card=document.createElement('article');const text=escape(review.text||'');const author=escape(review.author_name||'Google customer');card.innerHTML=`<div class="eloc__review-author"><span aria-hidden="true">${author.slice(0,1)}</span><div><strong>${author}</strong><br><small>${escape(review.relative_time_description||'')}</small></div></div><strong aria-label="${review.rating} out of 5 stars">★★★★★</strong><p>${text.length>360?`${text.slice(0,357)}…`:text}</p>`;track.appendChild(card)})})};if(window.google?.maps?.places){window.__initEdmontonReviews();return}if(!document.querySelector('[data-edmonton-google-places]')){const script=document.createElement('script');script.src=`https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&callback=__initEdmontonReviews`;script.async=true;script.defer=true;script.dataset.edmontonGooglePlaces='true';document.head.appendChild(script)}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sales-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-sales-extras]').forEach(section=>{const data=section.parentElement.querySelector('[data-sales-products]');if(!data)return;const products=JSON.parse(data.textContent);const sizeIndex=Number(section.dataset.sizeIndex||0);const normalize=value=>String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'').replace('double','full');const update=size=>{Object.entries(products).forEach(([index,product])=>{if(!product?.variants)return;const card=section.querySelector(`[data-upsell-index="${index}"]`);if(!card)return;const requested=normalize(card.dataset.upsellOptionValue);const needsExact=card.dataset.requiresSize==='true';let variant=product.variants.find(item=>item.options.some(option=>normalize(option)===normalize(size))&&(!requested||item.options.some(option=>normalize(option)===requested)));const button=card.querySelector('.js-upsell-add');const label=card.querySelector('[data-upsell-variant-label]');const price=card.querySelector('[data-upsell-price-display]');if(!variant&&needsExact){card.classList.add('upsell-card--unavailable');button.disabled=true;button.dataset.variantId='';button.textContent='Unavailable';label.textContent=`Not available in ${size}`;price.textContent='Size unavailable';return}if(!variant&&requested){variant=product.variants.find(item=>item.available&&item.options.some(option=>normalize(option)===requested));if(!variant){card.classList.add('upsell-card--unavailable');button.disabled=true;button.dataset.variantId='';button.textContent='Unavailable';label.textContent='Pillow height unavailable';price.textContent='Unavailable';return}}card.classList.remove('upsell-card--unavailable');variant||=product.variants.find(item=>item.available)||product.variants[0];if(!variant)return;button.dataset.variantId=variant.id;button.disabled=!variant.available;button.textContent=variant.available?'Add to cart':'Unavailable';label.textContent=variant.title;price.textContent=new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format(variant.price/100)})};document.addEventListener('on:variant:change',event=>update(event.detail?.variant?.options?.[sizeIndex]));update(section.dataset.currentSize);section.querySelectorAll('.js-upsell-add').forEach(button=>button.addEventListener('click',async event=>{const card=event.currentTarget.closest('.upsell-card');const status=card.querySelector('[data-upsell-card-status]');event.currentTarget.disabled=true;status.textContent='Adding…';try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(event.currentTarget.dataset.variantId),quantity:1}]})});if(!response.ok)throw new Error();status.textContent='Added to your cart.';event.currentTarget.textContent='Added ✓';setTimeout(()=>{event.currentTarget.textContent='Add to cart';status.textContent=''},2200)}catch(error){status.textContent='Could not add this item. Please try again.'}finally{event.currentTarget.disabled=false}}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-trial-cta"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-store-trial]').forEach((section) => {
  const open = section.querySelector('[data-store-trial-open]');
  const locations = section.querySelector('[data-store-trial-locations]');
  const result = section.querySelector('[data-store-result]');
  const stores = {
    calgary: { name: 'Calgary showroom', address: '6624 Centre St S, Calgary', phone: '(403) 455-4466', tel: '14034554466', map: 'https://www.google.com/maps/search/?api=1&query=Canadian+Mattress+6624+Centre+St+S+Calgary' },
    edmonton: { name: 'Edmonton showroom', address: '5111 99th St, Edmonton', phone: '(780) 455-4466', tel: '17804554466', map: 'https://maps.app.goo.gl/WpTxuAy8RXootrtcA' }
  };
  open?.addEventListener('click', () => { locations.hidden = false; open.hidden = true; });
  locations?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-store-choice]');
    if (!button) return;
    const store = stores[button.dataset.storeChoice];
    result.innerHTML = `<strong>${store.name}</strong><br>${store.address}<br>${store.phone}<br><a href="${store.map}" target="_blank" rel="noopener">Get directions</a><a href="tel:${store.tel}">Call store</a>`;
    result.hidden = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upholstered-beds-hub"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-furniture-builder]').forEach((builder) => {
  const systems = builder.querySelectorAll('input[type="radio"]');
  const styles = [...builder.querySelectorAll('[data-builder-style]')];
  const levelOptions = [...builder.querySelectorAll('[data-level-option]')];
  const resultImage = builder.querySelector('.furniture-builder__result-image img');
  const resultTitle = builder.querySelector('[data-builder-result-title]');
  const resultText = builder.querySelector('[data-builder-result-text]');
  const resultLink = builder.querySelector('[data-builder-result-link]');
  const styleHelp = builder.querySelector('[data-builder-style-help]');
  const productPanels = document.querySelectorAll('[data-builder-products] [data-products-system]');
  const standardText = resultText ? resultText.textContent : '';
  let selectedStyle = styles[0];
  let selectedLevelOption = levelOptions[0];

  const updateResult = () => {
    const selectedSystem = builder.querySelector('input[type="radio"]:checked')?.value || 'woodland';
    builder.classList.toggle('is-level', selectedSystem === 'level');
    productPanels.forEach((panel) => {
      panel.hidden = panel.dataset.productsSystem !== selectedSystem;
    });
    if (selectedSystem !== 'level') {
      if (styleHelp) styleHelp.textContent = styleHelp.dataset[`${selectedSystem}Text`];
      styles.forEach((style) => {
        const styleImage = style.querySelector('.furniture-builder__style-image img');
        if (!styleImage) return;
        styleImage.removeAttribute('srcset');
        styleImage.removeAttribute('sizes');
        styleImage.src = style.dataset[`${selectedSystem}Image`];
        styleImage.alt = style.dataset[`${selectedSystem}Title`];
      });
    }

    if (selectedSystem === 'level') {
      resultTitle.textContent = selectedLevelOption?.dataset.levelTitle || builder.dataset.levelTitle;
      resultLink.href = selectedLevelOption?.dataset.levelUrl || builder.dataset.levelUrl;
      resultText.textContent = selectedLevelOption?.dataset.levelText || builder.dataset.levelText;
      if (resultImage && builder.dataset.levelImage) {
        resultImage.removeAttribute('srcset');
        resultImage.removeAttribute('sizes');
        resultImage.src = builder.dataset.levelImage;
        resultImage.alt = selectedLevelOption?.dataset.levelTitle || builder.dataset.levelTitle;
      }
      return;
    }

    if (!selectedStyle) return;
    resultTitle.textContent = selectedStyle.dataset[`${selectedSystem}Title`];
    resultLink.href = selectedStyle.dataset[`${selectedSystem}Url`];
    resultText.textContent = standardText;
    if (resultImage) {
      resultImage.removeAttribute('srcset');
      resultImage.removeAttribute('sizes');
      resultImage.src = selectedStyle.dataset[`${selectedSystem}Image`];
      resultImage.alt = selectedStyle.dataset[`${selectedSystem}Title`];
    }
  };

  systems.forEach((system) => system.addEventListener('change', updateResult));
  styles.forEach((style) => {
    style.addEventListener('click', () => {
      styles.forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      selectedStyle = style;
      style.classList.add('is-selected');
      style.setAttribute('aria-pressed', 'true');
      updateResult();
    });
  });
  levelOptions.forEach((option) => {
    option.addEventListener('click', () => {
      levelOptions.forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      selectedLevelOption = option;
      option.classList.add('is-selected');
      option.setAttribute('aria-pressed', 'true');
      updateResult();
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
